export default function SubstractIcon({ className }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
      <g clipPath="url(#clip0_14269_32710)">
        <path d="M4.16797 9.16602H15.8346V10.8327H4.16797V9.16602Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_14269_32710">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
